/*
 * Handle miscellaneous functions
 * Modals, append new seller, delete seller, open seller details, filter period status, sorting, etc.
 */
export default function handleMisc() {
	jQuery(".multi-select").select2();

	/**
	 * Modals - close
	 */

	jQuery(".storeeez-modals .close-modal").click(function (e) {
		e.preventDefault();
		hideModal(jQuery(this).closest(".storeeez-modals"));
	});

	/**
	 * Modals - close on overlay click
	 */

	jQuery(".main__overlay").click(function () {
		hideModal(jQuery(".storeeez-modals"));
	});

	/**
	 * Modals - open
	 */

	jQuery(".open-modal").click(function (e) {
		e.preventDefault();
		let modal = jQuery(this).data("modal");
		jQuery("body").addClass("modal-show");
		jQuery(".storeeez-modals" + "." + modal).removeClass("hidden");
		jQuery(".main__overlay").removeClass("hidden");
	});

	/**
	 * Edit Popup - UNUSED.
	 */

	jQuery(".edit-seller.has-edit-options").click(function (e) {
		if (jQuery(e.target).is("a")) {
			return;
		}
		jQuery(".popup-menu")
			.not(jQuery(this).find(".popup-menu"))
			.addClass("hidden");
		jQuery(this).find(".popup-menu").toggleClass("hidden");
	});

	/**
	 * Close Popup - UNUSED.
	 */

	jQuery(document).click(function (e) {
		if (!jQuery(e.target).closest(".edit-seller.has-edit-options").length) {
			jQuery(".popup-menu").addClass("hidden");
		}
	});

	/**
	 * Append seller rows for both create-group and edit-group modals.
	 * Edit-group starts with a hidden template row; create-group starts visible.
	 */

	jQuery(".append-multiple-sellers").click(function () {
		let container = jQuery(this)
			.closest(".period-wrapper")
			.find(".append-new-seller");
		let template = jQuery(container).find(".seller-form").first();

		if (jQuery(container).hasClass("hidden")) {
			jQuery(container).removeClass("hidden");
			jQuery(template).find("input").val("");
		} else {
			let element = jQuery(template).clone()[0];

			jQuery(element).appendTo(container);
			jQuery(element).find("input").val("");
		}

		if (window.innerWidth < 748) {
			jQuery("html, body").animate(
				{
					scrollTop: jQuery(container).offset().top - 300,
				},
				200
			);
		}
	});

	/**
	 * Append new seller on manage-sellers page
	 */

	jQuery(".append-seller").click(function () {
		let container = jQuery(this)
			.closest(".period-wrapper")
			.find(".append-new-seller");

		jQuery(container).removeClass("hidden");
		jQuery(container).find("input").val("");
		jQuery(container).find("select").val("");

		if (window.innerWidth < 748) {
			jQuery("html, body").animate(
				{
					scrollTop: jQuery(container).offset().top - 300,
				},
				200
			);
		}
	});

	/**
	 * Delete selling process "Cart"
	 */

	jQuery(".delete-process").click(function (e) {
		e.preventDefault();
		let modal = jQuery(this).closest(".storeeez-modals");

		jQuery(modal).addClass("hidden");
	});

	/**
	 * Remove appending group seller
	 */

	jQuery(".append-new-seller").on("click", ".remove-seller", function () {
		if (
			jQuery(this).closest(".append-new-seller").find(".seller-form").length > 1
		) {
			jQuery(this).closest(".seller-form").remove();
		}
	});

	/**
	 * Remove single seller
	 */

	// jQuery(".remove-single-seller").click(function() {
	jQuery("body").on("click", ".remove-single-seller", function () {
		let influencer_id = jQuery(this).data("id") ?? null;
		let group_id = jQuery(this).data("group-id") ?? null;
		let element = jQuery(this).parent().closest(".seller-form");

		if (
			influencer_id &&
			group_id &&
			confirm(
				"Är du säker på att du vill radera denna säljare? Säljaren kommer att tas bort permanent."
			)
		) {
			let data = {
				action: "remove_influencer",
				group_id: group_id,
				influencer_id: influencer_id,
			};
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function (response) {
					if (response.status == "success") {
						jQuery(element).remove();
					} else if (response.status == "error") {
						console.log(response.message);
					}
				},
				error: function (response) {
					console.log(response);
				},
			});
		} else if (!influencer_id) {
			if (
				jQuery(this).closest(".append-new-seller").find(".seller-form").length >
				1
			) {
				jQuery(this).closest(".seller-form").remove();
			} else if (
				jQuery(this).parent().closest(".sellers").find(".seller-form").length >
				1
			) {
				jQuery(this).closest(".seller-form").find("input").val("");
				jQuery(this).closest(".append-new-seller").addClass("hidden");
			}
		}
	});

	/**
	 * Send registration link
	 */

	jQuery(".send-registration-link").click(function (e) {
		e.preventDefault();

		let sales_period_id = jQuery(this).data("sales-period") ?? null;
		let seller_id = jQuery(this).data("seller-id") ?? null;
		let element = jQuery(this);

		if (sales_period_id) {
			let data = {
				action: "send_register_unique_code",
				sales_period_id: sales_period_id,
				seller_id: seller_id,
			};
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function (response) {
					if (response.status == "success") {
						jQuery(element)
							.parent()
							.replaceWith(
								"<span class='cursor-default font-bold'>Skickat!</span>"
							);
					}
				},
				error: function (response) {
					console.log(response);
				},
			});
		}
	});

	/**
	 * Get user's contact details
	 * Used in Create sales period form.
	 */

	jQuery("#pickUpFromContactDetails").change(function () {
		let user_id = jQuery(this).val();
		let element = jQuery(this).closest("form");
		if (!jQuery(this).is(":checked")) {
			jQuery(element).find("input[name='receiver_name']").val("");
			jQuery(element).find("input[name='receiver_address']").val("");
			jQuery(element).find("input[name='receiver_zip']").val("");
			jQuery(element).find("input[name='receiver_city']").val("");
			jQuery(element).find("input[name='receiver_phonenumber']").val("");
		} else {
			if (user_id) {
				let data = {
					action: "get_user_contact_details",
					user_id: user_id,
				};
				jQuery.ajax({
					url: my_ajax_object.ajax_url,
					type: "POST",
					data: data,
					success: function (response) {
						if (response.status == "success") {
							jQuery(element)
								.find("input[name='receiver_name']")
								.val(response.data.name);
							jQuery(element)
								.find("input[name='receiver_address']")
								.val(response.data.address);
							jQuery(element)
								.find("input[name='receiver_zip']")
								.val(response.data.zip);
							jQuery(element)
								.find("input[name='receiver_city']")
								.val(response.data.city);
							jQuery(element)
								.find("input[name='receiver_phonenumber']")
								.val(response.data.phonenumber);
						}
					},
				});
			} else {
				jQuery(element).html("");
			}
		}
	});

	/**
	 * Cancel new seller
	 */

	jQuery(".cancel-new-seller").click(function () {
		let element = jQuery(this)
			.closest(".period-wrapper")
			.find(".append-new-seller");
		jQuery(element).addClass("hidden");

		// Empty fields
		jQuery(element).find("input").val("");
		jQuery(element).find("select").val("");
	});

	/**
	 * Retry login
	 */
	jQuery(document).on("click", "#retry-login", function () {
		var form = jQuery(".management-login");
		/* Show form */
		jQuery(form).show();
		/* Reset HTML & classes */
		jQuery(form).find("button").html("Logga in");
		jQuery(form).find("button").removeClass("!bg-transparent");
		jQuery(form).removeClass("opacity-50 pointer-events-none");
		jQuery(form).find("input[name='email']").val("");
        jQuery(form).find("input[name='password']").val("");
		/* Remove error message */
		jQuery("#login-error").remove();
	});

	/**
	 * Retry register
	 */

	jQuery(document).on("click", "#retry-register", function () {
		var form = jQuery(".management-register").length
			? jQuery(".management-register")
			: jQuery(".management-upgrade").length
			? jQuery(".management-upgrade")
			: jQuery(".sales-register");
		var button_label = jQuery(".management-upgrade").length ? "Bli föreningsledare" : "Registrera";
		/* Show form */
		jQuery(form).show();
		/* Reset HTML & classes */
		jQuery(form).find("button").html(button_label);
		jQuery(form).find("button").removeClass("!bg-transparent");
		jQuery(form).removeClass("opacity-50 pointer-events-none");
		jQuery(form).find("input").val("");
		/* Remove error message */
		jQuery("#register-error").remove();
	});

	/**
	 * Retry forgot password
	 */

	jQuery(document).on("click", "#retry-forgot-password", function () {
		var form = jQuery(".management-forgot-password");
		/* Show form */
		jQuery(form).show();
		/* Reset HTML & classes */
		jQuery(form).find("button").html("Skicka");
		jQuery(form).find("button").removeClass("!bg-transparent");
		jQuery(form).removeClass("opacity-50 pointer-events-none");
		jQuery(form).find("input").val("");
		/* Remove error message */
		jQuery("#forgot-password-error").remove();
	});

	/**
	 * Open seller-details
	 */

	jQuery(".period-wrapper .open-selldetails").click(function () {
		jQuery(this)
			.toggleClass("active")
			.find("span")
			.html(jQuery(this).hasClass("active") ? "Dölj säljare" : "Visa säljare");
		jQuery(this)
			.parent()
			.closest(".period-wrapper")
			.find(".period-seller-details")
			.toggleClass("hidden");
	});

	/**
	 * Filter period status
	 */

	jQuery(".period-filter-status > .filter-btn").click(function () {
		jQuery(".period-filter-status > .filter-btn").removeClass("active");

		let status = jQuery(this).data("status");

		jQuery(this).toggleClass("active");

		jQuery(".period-wrapper").each(function () {
			if (status == "all") {
				jQuery(this).removeClass("hidden");
			} else {
				jQuery(this).addClass("hidden");
				jQuery(this)
					.filter(function () {
						return jQuery(this).data("status") == status;
					})
					.removeClass("hidden");
			}
		});
	});

	/**
	 * Sorting - WIP
	 */

	jQuery(".management-sorting").click(function () {
		let sortValue = jQuery(this).data("sort");

		jQuery(this)
			.parent()
			.closest("table")
			.find("th > .management-sort-holder")
			.each(function () {
				jQuery(this).removeClass("active");
			});
	});

	/**
	 * ESC key
	 */

	jQuery(document).keyup(function (e) {
		if (e.key === "Escape") {
			hideModal(jQuery(".storeeez-modals"));
		}
	});

	/**
	 * Reset update user details
	 */

	jQuery(".reset-user-details").click(function (e) {
		e.preventDefault();
		let form = jQuery(this).closest("form");

		jQuery(form)
			.find(".form-control")
			.each(function () {
				let value = jQuery(this).find("input[type='hidden']").val();
				jQuery(this).find("input:not([type='hidden'])").val(value);
			});
	});
	/**
	 * Quantity and price handling for new orders
	 */
	jQuery("body").on("click", ".new-order-cart .quantity .btn", function (e) {
		e.preventDefault();

		const cartItem = jQuery(this).closest(".cart-item");
		const row = jQuery(this).closest(".variation-row");
		const input = jQuery(this).closest(".quantity").find("input");
		let value = parseInt(jQuery(input).val()) || 0;

		// Update quantity
		if (jQuery(this).hasClass("plus")) {
			value++;
		} else if (jQuery(this).hasClass("minus")) {
			value = Math.max(0, value - 1);
		}

		jQuery(input).val(value);
		if (input[0]) {
			input[0].value = value;
		}

		// If this is a variable product, sync quantities and row state
		if (cartItem.hasClass("variable-product")) {
			ensureRowData(cartItem, row);
			const lockChanged = updateRowLockState(row);
			syncVariationQuantities(cartItem);
			if (lockChanged) {
				updateRowOptions(cartItem);
			}
		}

		// Calculate total price across all items
		updateTotalPrice(jQuery(this).closest("#new-order"));
	});

	/**
	 * Handle variation attribute selection changes
	 */
	jQuery("body").on("input change", ".new-order-cart .cart-item.variable-product .quantity input", function () {
		const cartItem = jQuery(this).closest(".cart-item");
		const row = jQuery(this).closest(".variation-row");
		ensureRowData(cartItem, row);
		const lockChanged = updateRowLockState(row);
		syncVariationQuantities(cartItem);
		if (lockChanged) {
			updateRowOptions(cartItem);
		}
		updateTotalPrice(cartItem.closest("#new-order"));
	});

	jQuery("body").on("focus", ".new-order-cart .cart-item.variable-product .variation-select", function () {
		const row = jQuery(this).closest(".variation-row");
		setRowSelectedAttributes(row, getSelectedAttributes(row));
	});

	jQuery("body").on("change", ".new-order-cart .cart-item.variable-product .variation-select", function () {
		const cartItem = jQuery(this).closest(".cart-item");
		const row = jQuery(this).closest(".variation-row");
		handleVariationChange(cartItem, row);
	});

	/**
	 * Handles variation selection changes for variable products
	 * @param {jQuery} cartItem - The cart item element
	 * @param {jQuery} row - The variation row element
	 */
	function handleVariationChange(cartItem, row) {
		const wasLocked = isRowLocked(row);
		const previousAttributes = row.data("selectedAttributes") || getSelectedAttributes(row);
		const nextAttributes = getSelectedAttributes(row);

		if (wasLocked) {
			setRowSelections(row, previousAttributes);
			updateRowVariation(cartItem, row);

			const newRow = row.clone();
			newRow.removeClass("variation-locked");
			newRow.removeAttr("data-current-variation-id");
			newRow.removeData("current-variation-id");
			newRow.find(".quantity input").val(0);
			if (newRow.find(".quantity input")[0]) {
				newRow.find(".quantity input")[0].value = 0;
			}
			setRowSelections(newRow, nextAttributes);
			row.after(newRow);

			updateRowOptions(cartItem);
			updateRowVariation(cartItem, newRow);
			setRowSelectedAttributes(newRow, getSelectedAttributes(newRow));

			syncVariationQuantities(cartItem);
			updateTotalPrice(cartItem.closest("#new-order"));
			return;
		}

		updateRowOptions(cartItem, row);
		updateRowVariation(cartItem, row);
		setRowSelectedAttributes(row, getSelectedAttributes(row));
		syncVariationQuantities(cartItem);
		updateTotalPrice(cartItem.closest("#new-order"));
	}

	function ensureRowData(cartItem, row) {
		if (!row || !row.length) return;
		if (!row.data("current-variation-id")) {
			updateRowVariation(cartItem, row);
		}
		if (!row.data("selectedAttributes")) {
			setRowSelectedAttributes(row, getSelectedAttributes(row));
		}
	}

	function getSelectedAttributes(row) {
		const selectedAttributes = {};
		row.find(".variation-select").each(function () {
			const attributeName = jQuery(this).data("attribute");
			const attributeValue = jQuery(this).val();
			selectedAttributes[attributeName] = attributeValue;
		});
		return selectedAttributes;
	}

	function setRowSelections(row, attributes) {
		row.find(".variation-select").each(function () {
			const attributeName = jQuery(this).data("attribute");
			if (attributes && Object.prototype.hasOwnProperty.call(attributes, attributeName)) {
				jQuery(this).val(attributes[attributeName]);
			}
		});
	}

	function setRowSelectedAttributes(row, attributes) {
		row.data("selectedAttributes", attributes || {});
	}

	function isRowLocked(row) {
		const qty = parseInt(row.find(".quantity input").val()) || 0;
		return qty > 0;
	}

	function updateRowLockState(row) {
		const locked = isRowLocked(row);
		const wasLocked = row.hasClass("variation-locked");
		if (locked) {
			row.addClass("variation-locked");
		} else {
			row.removeClass("variation-locked");
		}
		return locked !== wasLocked;
	}

	function getLockedVariationIds(cartItem, excludeRow) {
		const lockedIds = new Set();
		cartItem.find(".variation-row").each(function () {
			const row = jQuery(this);
			if (excludeRow && excludeRow.length && row[0] === excludeRow[0]) {
				return;
			}
			const qty = parseInt(row.find(".quantity input").val()) || 0;
			const variationId = row.data("current-variation-id");
			if (qty > 0 && variationId) {
				lockedIds.add(String(variationId));
			}
		});
		return lockedIds;
	}

	function updateRowOptions(cartItem, row) {
		const variations = cartItem.data("variations");
		if (!variations) return;

		if (row) {
			updateRowOptionsForRow(cartItem, row, variations);
			return;
		}

		cartItem.find(".variation-row").each(function () {
			updateRowOptionsForRow(cartItem, jQuery(this), variations);
		});
	}

	function updateRowOptionsForRow(cartItem, row, variations) {
		const lockedIds = getLockedVariationIds(cartItem, row);
		const availableVariations = variations.filter(variation => !lockedIds.has(String(variation.variation_id)));
		const selections = getSelectedAttributes(row);
		let selectionChanged = false;

		row.find(".variation-select").each(function () {
			const select = jQuery(this);
			const attributeName = select.data("attribute");
			const allowedValues = new Set();

			availableVariations.forEach(variation => {
				if (matchesSelections(variation.attributes, selections, attributeName)) {
					const value = variation.attributes[attributeName];
					if (value) {
						allowedValues.add(value.toLowerCase());
					}
				}
			});

			if (!allowedValues.size) {
				select.find("option").prop("disabled", false).prop("hidden", false);
				return;
			}

			select.find("option").each(function () {
				const optionValue = (jQuery(this).val() || "").toLowerCase();
				const isAllowed = allowedValues.has(optionValue);
				jQuery(this).prop("disabled", !isAllowed).prop("hidden", !isAllowed);
			});

			const currentValue = (select.val() || "").toLowerCase();
			if (!allowedValues.has(currentValue)) {
				const firstAllowed = select.find("option").filter(function () {
					return !jQuery(this).prop("disabled");
				}).first().val();
				if (firstAllowed) {
					select.val(firstAllowed);
					selectionChanged = true;
				}
			}
		});

		if (selectionChanged) {
			updateRowVariation(cartItem, row);
		}
	}

	function matchesSelections(variationAttributes, selections, excludeAttribute) {
		return Object.keys(selections).every(attrName => {
			if (attrName === excludeAttribute) return true;
			const selectedValue = selections[attrName];
			const variationValue = variationAttributes[attrName];
			if (!selectedValue || !variationValue) return false;
			return variationValue.toLowerCase() === selectedValue.toLowerCase();
		});
	}

	function updateRowVariation(cartItem, row) {
		const variations = cartItem.data("variations");
		if (!variations) return;

		const selectedAttributes = getSelectedAttributes(row);
		const lockedIds = getLockedVariationIds(cartItem, row);
		const matchedVariation = variations.find(variation => {
			if (lockedIds.has(String(variation.variation_id))) return false;
			return Object.keys(selectedAttributes).every(attrName => {
				const varAttr = variation.attributes[attrName];
				const selAttr = selectedAttributes[attrName];
				if (!varAttr || !selAttr) return false;
				return varAttr.toLowerCase() === selAttr.toLowerCase();
			});
		});

		if (!matchedVariation) {
			console.error("No matching variation found for attributes:", selectedAttributes);
			return;
		}

		row.data("current-variation-id", matchedVariation.variation_id);
		row.find(".price-display").html(`${formatPrice(matchedVariation.price)} inkl. moms`);
		row.find(".quantity .btn").data("price", matchedVariation.price);
		setRowSelectedAttributes(row, selectedAttributes);
	}

	function syncVariationQuantities(cartItem) {
		const quantities = {};
		cartItem.find(".variation-row").each(function () {
			const row = jQuery(this);
			const qty = parseInt(row.find(".quantity input").val()) || 0;
			const variationId = row.data("current-variation-id");
			if (qty > 0 && variationId) {
				quantities[variationId] = qty;
			}
		});
		cartItem.find(".variation-quantities").val(JSON.stringify(quantities));
	}

	/**
	 * Gets the variation quantities from the hidden input
	 * @param {jQuery} cartItem - The cart item element
	 * @returns {Object} - Object mapping variation IDs to quantities
	 */
	function getVariationQuantities(cartItem) {
		try {
			const json = cartItem.find(".variation-quantities").val();
			return JSON.parse(json || "{}");
		} catch (e) {
			return {};
		}
	}

	/**
	 * Formats price for display (simple implementation)
	 * @param {number} price - The price to format
	 * @returns {string} - Formatted price string
	 */
	function formatPrice(price) {
		return `${price.toFixed(0)} kr`;
	}

	/**
	 * Calculates total price of all items in cart and updates display
	 * @param {jQuery} form - The form containing the cart items
	 */
	function updateTotalPrice(form) {
		let total = 0;

		jQuery(form)
			.find(".new-order-cart .cart-item")
			.each(function () {
				const cartItem = jQuery(this);

				// Check if this is a variable product
				if (cartItem.hasClass("variable-product")) {
					// Get saved variation quantities from hidden input
					const quantities = getVariationQuantities(cartItem);
					const variations = cartItem.data("variations");

					if (!variations) return;

					// Loop through each saved variation quantity
					Object.keys(quantities).forEach(function (variationId) {
						const qty = quantities[variationId];
						if (qty > 0) {
							// Find the variation data to get its price
							const variation = variations.find(v => v.variation_id == variationId);
							if (variation) {
								total += qty * variation.price;
							}
						}
					});
				} else {
					// Simple product - use existing logic
					const quantity = parseInt(cartItem.find(".quantity input").val()) || 0;
					const price = parseFloat(cartItem.find(".quantity .btn.plus").data("price")) || 0;
					total += quantity * price;
				}
			});

		const totalPriceContainer = jQuery(form).find("#total-price");

		if (total > 0) {
			totalPriceContainer
				.css("display", "flex")
				.html(`Totalt: ${total.toFixed(0)} kr`);
		} else {
			totalPriceContainer.css("display", "none");
		}
	}

	/**
	 * Open proccess cart
	 */

	jQuery(".proccess_item .open_proccess_cart").click(function () {
		jQuery(this).toggleClass("active").find("span").toggleClass("hidden");
		jQuery(this)
			.closest(".proccess_item")
			.find(".proccess_cart")
			.toggleClass("hidden");
	});

	jQuery(".qricon").click(function () {
		var qrcode = jQuery(this).data("qrcode");
		jQuery("#qrcode-" + qrcode).toggleClass("hidden");
	});

	jQuery(".qrcode").each(function () {
		var qrcode = jQuery(this).attr("id");
		var val = jQuery(this).data("val");
		if (val) {
			new QRCode(document.getElementById(qrcode), {
				text: val,
				width: 256,
				height: 256,
				colorDark: "#000000",
			colorLight: "#ffffff",
			correctLevel: QRCode.CorrectLevel.H
			});
		}
	});

	/**
	 * Copy to clipboard
	 */

	jQuery(".copy-to-clipboard").click(function () {
		let copyText = jQuery(this)
			.parent()
			.closest(".copy-to-clipboard-wrapper")
			.find(".copy-text")
			.html();
		let originalText = jQuery(this).html();
		navigator.clipboard.writeText(copyText).then(function () {
			jQuery(".copy-to-clipboard")
				.addClass("bg-black text-white px-3 py-1 pointer-events-none")
				.html("Kopierad!");

			setTimeout(function () {
				jQuery(".copy-to-clipboard")
					.removeClass("bg-black text-white px-3 py-1 pointer-events-none")
					.html(originalText);
			}, 10000);
		});
	});

	jQuery(".sharer").on("click", function () {
		let copyText = jQuery(this).data("link");
		let title = jQuery(this).data("title");
		let text = jQuery(this).data("text");
		if (!navigator.share) {
			navigator.clipboard.writeText(copyText).then(function () {
				alert("Kopierad!");
			});
		} else {
			let shareData = {
				title: title,
				text: text,
				url: copyText
			};
			navigator.share(shareData);
		}
	});

jQuery(function () {
		function getNewOrderProductsForm(el) {
			if (el && el.type) {
				el = el.target;
			}

			let $form = jQuery(el);

			let category_id = $form.find("input[name='product_category']").val();
			let wrapper = $form.find(".new-order-cart");
			let submit = $form.find("button.submit");

			jQuery(wrapper).html(`
		<div class='load-spin'><div></div><div></div><div></div></div>
		`);

			if (category_id) {
				let data = {
					action: "get_products_from_category",
					category_id: category_id,
				};

				jQuery.ajax({
					url: my_ajax_object.ajax_url,
					type: "POST",
					data: data,
					success: function (response) {
						if (response.status == "success") {
							jQuery(wrapper).html(response.html);

							jQuery(submit).removeAttr("disabled");
						} else if (response.status == "error") {
							jQuery(wrapper).html(
								"<span class='w-fit bg-dark px-4 py-2 font-bold text-white'>" +
									response.message +
									"</span>"
							);
							jQuery(submit).attr("disabled", "disabled");
						}
					},
				});
			} else {
				jQuery(wrapper).html("");
				jQuery(submit).attr("disabled", "disabled");
			}
		}

		const form = document.querySelector("#new-order");
		if (form) {
	        getNewOrderProductsForm(document.querySelector("#new-order"));
		}
	});

	/**
	 * Category filter for new order products
	 */
	jQuery(function () {
		const $filterWrapper = jQuery('.category-filter-wrapper');
		if (!$filterWrapper.length) return;

		const $filterToggle = $filterWrapper.find('.category-filter-toggle');
		const $filterContent = $filterWrapper.find('.category-filter-content');
		const $selectsContainer = $filterWrapper.find('.category-selects-container');
		const $resetButton = $filterWrapper.find('.category-filter-reset');
		const $chevronIcon = $filterWrapper.find('.chevron-icon');
		const $cart = jQuery('.new-order-cart');

		let allProducts = [];
		let selectedCategories = [];
		let categoryDescendants = {}; // Map of category ID -> all descendant IDs

		// Check if filter should be visible
		function updateFilterVisibility() {
			const parentCategoryId = $filterWrapper.data('parent-category');
			if (parentCategoryId && parentCategoryId !== '') {
				$filterWrapper.show();
			} else {
				$filterWrapper.hide();
				$filterContent.addClass('hidden');
				$chevronIcon.removeClass('rotate-180');
			}
		}

		// Store all products when they're loaded
		function storeAllProducts() {
			allProducts = [];
			$cart.find('.cart-item-modal').each(function() {
				const $item = jQuery(this);
				const categories = $item.data('categories') || [];
				allProducts.push({
					element: $item.clone(true),
					categories: Array.isArray(categories) ? categories : [categories]
				});
			});
		}

		// Filter products based on selected categories
		function filterProducts() {
			if (selectedCategories.length === 0) {
				// No filter selected, show all products
				$cart.find('.cart-item-modal').show();
				return;
			}

			const selectedCategory = selectedCategories[selectedCategories.length - 1];

			// Build array of all valid category IDs (selected + all descendants)
			const validCategoryIds = [selectedCategory];
			if (categoryDescendants[selectedCategory]) {
				validCategoryIds.push(...categoryDescendants[selectedCategory]);
			}

			$cart.find('.cart-item-modal').each(function() {
				const $item = jQuery(this);
				const itemCategories = $item.data('categories') || [];
				const categories = Array.isArray(itemCategories) ? itemCategories : [itemCategories];

				// Check if product has any category that matches selected or descendants
				const hasMatchingCategory = categories.some(catId => validCategoryIds.includes(catId));

				if (hasMatchingCategory) {
					$item.show();
				} else {
					$item.hide();
				}
			});
		}

		// Reset filter state
		function resetFilter() {
			selectedCategories = [];
			$selectsContainer.empty();
			$filterContent.addClass('hidden');
			$chevronIcon.removeClass('rotate-180');
			filterProducts();
		}

		// Update parent category (called when sales period changes)
		function updateParentCategory(newCategoryId) {
			$filterWrapper.data('parent-category', newCategoryId);
			resetFilter();
			updateFilterVisibility();
		}

		// Toggle filter visibility
		$filterToggle.on('click', function() {
			const parentCategoryId = $filterWrapper.data('parent-category');
			if (!parentCategoryId || parentCategoryId === '') {
				return; // Don't open if no parent category
			}

			$filterContent.toggleClass('hidden');
			$chevronIcon.toggleClass('rotate-180');

			// Load initial categories when opening for the first time
			if (!$filterContent.hasClass('hidden') && $selectsContainer.is(':empty')) {
				if (parentCategoryId) {
					loadCategories(parentCategoryId, 0);
				}
			}
		});

		// Load categories from server
		function loadCategories(parentId, level) {
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: {
					action: 'get_child_categories',
					parent_id: parentId
				},
				success: function(response) {
					if (response.status === 'success' && response.categories.length > 0) {
						// Store descendant IDs for this parent category
						if (response.all_descendant_ids) {
							categoryDescendants[parentId] = response.all_descendant_ids;
						}
						createCategorySelect(response.categories, level);
					}
				}
			});
		}

		// Create a select dropdown for categories
		function createCategorySelect(categories, level) {
			// Remove all selects after this level
			$selectsContainer.find(`[data-level="${level}"]`).nextAll().remove();
			$selectsContainer.find(`[data-level="${level}"]`).remove();

			// Trim selected categories array to current level
			selectedCategories = selectedCategories.slice(0, level);

			// If only one category, auto-select it and load children
			if (categories.length === 1) {
				selectedCategories[level] = categories[0].id;
				loadCategories(categories[0].id, level + 1);
				filterProducts();
				return;
			}

			// Create select element
			const $select = jQuery('<select>', {
				class: 'min-h-[48px] w-full border-[1px] border-dark p-2.5',
				'data-level': level
			});

			// Add default option
			$select.append(jQuery('<option>', {
				value: '',
				text: 'Välj kategori'
			}));

			// Add category options
			categories.forEach(function(category) {
				$select.append(jQuery('<option>', {
					value: category.id,
					text: category.name
				}));
			});

			// Handle selection change
			$select.on('change', function() {
				const selectedId = parseInt(jQuery(this).val());

				if (selectedId) {
					selectedCategories[level] = selectedId;

					// Trim array to remove old deeper selections
					selectedCategories = selectedCategories.slice(0, level + 1);

					// Remove all deeper level selects
					jQuery(this).nextAll().remove();

					// Apply filter immediately with the newly selected category
					filterProducts();

					// Then try to load child categories
					loadCategories(selectedId, level + 1);
				} else {
					// Clear selection at this level and deeper
					selectedCategories = selectedCategories.slice(0, level);
					jQuery(this).nextAll().remove();
					filterProducts();
				}
			});

			$selectsContainer.append($select);
		}

		// Reset filter
		$resetButton.on('click', function() {
			selectedCategories = [];
			$selectsContainer.empty();
			const parentCategoryId = $filterWrapper.data('parent-category');
			if (parentCategoryId) {
				loadCategories(parentCategoryId, 0);
			}
			filterProducts();
		});

		// Store products when cart is populated
		const cartObserver = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.addedNodes.length > 0) {
					storeAllProducts();
				}
			});
		});

		if ($cart.length) {
			cartObserver.observe($cart[0], { childList: true });
			storeAllProducts();
		}

		// Listen for sales period changes and update filter parent category
		const $salesPeriodSelect = jQuery("select[name='sales_period']");
		if ($salesPeriodSelect.length) {
			$salesPeriodSelect.on('change', function() {
				const categoryId = jQuery(this).val();
				updateParentCategory(categoryId);
			});
		}

		// Also listen for changes in forms with pre-loaded sales periods
		const $form = jQuery('#new-order');
		if ($form.length) {
			const $productCategoryInput = $form.find("input[name='product_category']");
			if ($productCategoryInput.length && $productCategoryInput.val()) {
				// Initialize with pre-loaded category
				updateParentCategory($productCategoryInput.val());
			}
		}

		// Initial visibility check
		updateFilterVisibility();
	});

	/**
	 * Buyer information collapsible toggle
	 */
	jQuery(function () {
		const $buyerInfoWrapper = jQuery('.buyer-info-wrapper');
		if (!$buyerInfoWrapper.length) return;

		const $buyerInfoToggle = $buyerInfoWrapper.find('.buyer-info-toggle');
		const $buyerInfoContent = $buyerInfoWrapper.find('.buyer-info-content');
		const $chevronIcon = $buyerInfoWrapper.find('.chevron-icon');

		// Toggle buyer info visibility
		$buyerInfoToggle.on('click', function() {
			$buyerInfoContent.toggleClass('hidden');
			$chevronIcon.toggleClass('rotate-180');
		});
	});

	/**
	 * New order - append products based on selected sellperiod
	 */

	jQuery(function () {
		function getNewOrderProducts(el) {
			if (el && el.type) {
				el = el.target;
			}

			let $select = jQuery(el);

			let category_id = $select.val();
			let wrapper = $select.closest("form").find(".new-order-cart");
			let submit = $select.closest("form").find("button.submit");

			jQuery(wrapper).html(`
		<div class='load-spin'><div></div><div></div><div></div></div>
		`);

			if (category_id) {
				let data = {
					action: "get_products_from_category",
					category_id: category_id,
				};

				jQuery.ajax({
					url: my_ajax_object.ajax_url,
					type: "POST",
					data: data,
					success: function (response) {
						if (response.status == "success") {
							jQuery(wrapper).html(response.html);

							jQuery(submit).removeAttr("disabled");
						} else if (response.status == "error") {
							jQuery(wrapper).html(
								"<span class='w-fit bg-dark px-4 py-2 font-bold text-white'>" +
									response.message +
									"</span>"
							);
							jQuery(submit).attr("disabled", "disabled");
						}
					},
				});
			} else {
				jQuery(wrapper).html("");
				jQuery(submit).attr("disabled", "disabled");
			}
		}

		const $select = jQuery(".modal-new-order form select[name='sales_period']");
		if ($select.length) {
			let $options = $select.find("option");
			if ($options.length == 2) {
				$options.eq($options.length - 1).prop("selected", true);

				getNewOrderProducts($select);

				$select.trigger("change");
			}

			// Attach the handler for frontend/UX interaction
			$select.on("change", getNewOrderProducts);
		}
	});

	/**
	 * Appends new product to order.
	 * Currently used in "My sellperiods" -> "Edit infleuncer order".
	 */

	jQuery(".edit-period-influencer-order .new-order-item").click(function () {
		let wrapper = jQuery(this).parent().find(".append-wrapper");
		let html = jQuery(this)
			.parent()
			.find(".append-new-order-item.hidden")
			.clone()[0];

		jQuery(html).find(".quantity input").val(1);
		jQuery(html).find("select[name='product']").val("");

		jQuery(html)
			.appendTo(jQuery(wrapper))
			.removeClass("hidden")
			.addClass("new-order-cart");
	});

	jQuery("body").on(
		"click",
		".edit-period-influencer-order .new-order-cart .remove",
		function () {
			if (
				jQuery(this).parent().closest(".append-wrapper").find(".new-order-cart")
					.length > 1
			) {
				jQuery(this).closest(".new-order-cart").remove();
			}
		}
	);

	/**
	 * Appends new order for influencer.
	 * Currently used in "My sellperiods" -> "Edit infleuncer order".
	 */

	jQuery(
		".edit-period-influencer-order .append-new-order, .edit-period-influencer-order .cancel-new-order"
	).click(function () {
		let wrapper = jQuery(this)
			.closest(".edit-period-influencer-order")
			.find(".appending-new-order");
		jQuery(wrapper)
			.find("input[name='name']")
			.prop("required", function (i, v) {
				return !v;
			});
		jQuery(wrapper).toggleClass("hidden");
		jQuery(".edit-period-influencer-order .append-new-order").toggleClass(
			"hidden"
		);
	});

	/**
	 * Activate points in checkout
	 */

	jQuery(document).on("change", "#add_points", function () {
		var points = jQuery(this).val();
		points = points.replace(/[^0-9\.]+/g, "");
		if (jQuery(this).is(":checked")) {
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				type: "POST",
				data: {
					action: "update_new_price_from_points",
					points: points,
				},
				success: function (response) {
					if (response.success) {
						jQuery(document.body).trigger("update_checkout");
					}
				},
			});
		} else {
			jQuery.ajax({
				url: my_ajax_object.ajax_url,
				type: "POST",
				data: {
					action: "remove_points_discount",
				},
				success: function (response) {
					if (response.success) {
						jQuery(document.body).trigger("update_checkout");
					}
				},
			});
		}
	});

	function hideModal(modal, resetModal) {
		if (jQuery(modal).hasClass("modal-closing")) {
			return;
		}

		jQuery(modal).addClass("modal-closing");

		setTimeout(function () {
			jQuery(modal).addClass("hidden").removeClass("modal-closing");
		}, 300);

		jQuery("body").removeClass("modal-show");
		jQuery(".main__overlay").addClass("hidden");

		if (resetModal) {
			resetModal(modal);
		}

		/**
		 * Reload page on overlay click when form is submitted
		 */
		if (jQuery("body").hasClass("modal-handled")) {
			location.reload();
		}
	}

	function parseWooAmount(text) {
		return parseFloat(
			text
			.replace(/\u00A0/g, ' ')     // NBSP -> space
			.replace(/\s/g, '')         // remove spaces
			.replace(/[^\d,.-]/g, '')   // remove currency
			.replace(',', '.')          // Swedish decimal
		) || 0;
	}

	/** These are workarounds for how PW and Kustom work together */
	jQuery(function ($) {
		const KUSTOM_SELECTORS = [
			'#klarna-checkout-container', // example
		];

		$(document.body).on('wc_update_cart', function () {
			location.reload();
		});

		function kustomMissing() {
			for (const sel of KUSTOM_SELECTORS) {
				const $el = $(sel);
				if ($el.length) {
					const hasContent = $.trim($el.html()).length > 0;
					const visible = $el.is(':visible');
					return !(hasContent && visible);
				}
			}
			return true;
		}

		function reloadOnceIfMissing() {
			const key = 'kustom_reload_attempted';
			if (sessionStorage.getItem(key) === '1') {
				sessionStorage.removeItem(key);
				return;
			}
			if (kustomMissing()) {
				sessionStorage.setItem(key, '1');
				window.location.reload();
			} else {
				sessionStorage.removeItem(key);
			}
		}

		$(document.body).on('updated_checkout', function () {
			if ($('.payment_method_cod').length) {
				return;
			}
			const total = parseWooAmount($('.order-total .amount').first().text());
			if (total === 0) {
				return;
			}
			setTimeout(reloadOnceIfMissing, 300);
		});

		$(document.body).on('checkout_error', function () {
			sessionStorage.removeItem('kustom_reload_attempted');
		});
	});
}
